import {Component, Input} from '@angular/core';
import {Company} from "../../../../interfaces/company.interface";

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent {
  @Input() report: any;
  @Input() company: Company;
  @Input() edit: boolean | undefined;
}
